import { useEffect, useState } from 'react';
import { DataSyncItem, MappingMode } from '../types/DataSyncItem';
import { DataSyncObjectsStore } from '../stores/object/DataSyncObjectsStore';
import { DataSyncMappingService } from '../services/DataSync/DataSyncMappingService';

export function useFieldMappingMode(
  formEditMode: 'create' | 'edit',
  dataSync: DataSyncItem,
  sourceStore: DataSyncObjectsStore | null,
  destinationStore: DataSyncObjectsStore | null,
  storesLoaded: boolean
): [MappingMode | undefined, (mode: MappingMode) => void] {
  const initialMode = formEditMode === 'create' ? MappingMode.EDITABLE : undefined;
  const [fieldMappingMode, setFieldMappingMode] = useState<MappingMode | undefined>(initialMode);

  useEffect(() => {
    if (storesLoaded) {
      DataSyncMappingService.determineInitialMappingMode(
        dataSync,
        sourceStore,
        destinationStore
      ).then((mode) => {
        setFieldMappingMode(mode);
      });
    }
  }, [storesLoaded]);

  return [fieldMappingMode, setFieldMappingMode];
}
